import { render, staticRenderFns } from "./ProfilePictureForm.vue?vue&type=template&id=2a465a10"
import script from "./ProfilePictureForm.vue?vue&type=script&lang=js"
export * from "./ProfilePictureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports